import {
    APPLICATION_RESET_STATE,
    APPLICATION_RESET_STATE_SUCCESSFUL,
    APPLICATION_RESET_STATE_FAILED,
    APPLICATION_PERSONAL_INFORMATION,
    APPLICATION_PERSONAL_INFORMATION_SUCCESSFUL,
    APPLICATION_PERSONAL_INFORMATION_FAILED,
    APPLICATION_UPDATE_ADDRESS,
    APPLICATION_UPDATE_ADDRESS_SUCCESSFUL,
    APPLICATION_UPDATE_ADDRESS_FAILED,
    APPLICATION_INCOME_INFORMATION,
    APPLICATION_INCOME_INFORMATION_SUCCESSFUL,
    APPLICATION_INCOME_INFORMATION_FAILED,
    APPLICATION_RESIDENCY_INFORMATION,
    APPLICATION_RESIDENCY_INFORMATION_SUCCESSFUL,
    APPLICATION_RESIDENCY_INFORMATION_FAILED,
    APPLICATION_REFERENCE_INFORMATION,
    APPLICATION_REFERENCE_INFORMATION_SUCCESSFUL,
    APPLICATION_REFERENCE_INFORMATION_FAILED,
    APPLICATION_ACCESS_CODE,
    APPLICATION_ACCESS_CODE_SUCCESSFUL,
    APPLICATION_ACCESS_CODE_FAILED,
    APPLICATION_VALIDATE_ACCESS_CODE,
    APPLICATION_VALIDATE_ACCESS_CODE_SUCCESSFUL,
    APPLICATION_VALIDATE_ACCESS_CODE_FAILED,
    APPLICATION_START_CO_SIGNER,
    APPLICATION_START_CO_SIGNER_SUCCESSFUL,
    APPLICATION_START_CO_SIGNER_FAILED,
    APPLICATION_INVITE_CO_EMAIL,
    APPLICATION_INVITE_CO_EMAIL_SUCCESSFUL,
    APPLICATION_INVITE_CO_EMAIL_FAILED,
    APPLICATION_INVITE_CO_SMS,
    APPLICATION_INVITE_CO_SMS_SUCCESSFUL,
    APPLICATION_INVITE_CO_SMS_FAILED,
  } from "./actionTypes"
  
  export const applicationResetState = (path, history) => {
    return {
      type: APPLICATION_RESET_STATE,
      payload: { path, history },
    }
  }
  
  export const applicationResetStateSuccessful = () => {
    return {
      type: APPLICATION_RESET_STATE_SUCCESSFUL,
      payload: {},
    }
  }
  
  export const applicationResetStateFailed = error => {
    return {
      type: APPLICATION_RESET_STATE_FAILED,
      payload: error,
    }
  }
  
  export const applicationPersonalInformation = (applicant, history) => {
    return {
      type: APPLICATION_PERSONAL_INFORMATION,
      payload: { applicant, history },
    }
  }
  
  export const applicationPersonalInformationSuccessful = applicant => {
    return {
      type:  APPLICATION_PERSONAL_INFORMATION_SUCCESSFUL,
      payload: applicant,
    }
  }
  
  export const applicationPersonalInformationFailed = error => {
    return {
      type: APPLICATION_PERSONAL_INFORMATION_FAILED,
      payload: error,
    }
  }
  
  export const applicationUpdateAddress = (applicantType, address, history) => {
    return {
      type: APPLICATION_UPDATE_ADDRESS,
      payload: { applicantType, address, history },
    }
  }
  
  export const applicationUpdateAddressSuccessful = address => {
    return {
      type:  APPLICATION_UPDATE_ADDRESS_SUCCESSFUL,
      payload: address,
    }
  }
  
  export const applicationUpdateAddressFailed = error => {
    return {
      type: APPLICATION_UPDATE_ADDRESS_FAILED,
      payload: error,
    }
  }
  
  export const applicationIncomeInformation = (applicantType, income, history) => {
    return {
      type: APPLICATION_INCOME_INFORMATION,
      payload: { applicantType, income, history },
    }
  }
  
  export const applicationIncomeInformationSuccessful = income => {
    return {
      type:  APPLICATION_INCOME_INFORMATION_SUCCESSFUL,
      payload: income,
    }
  }
  
  export const applicationIncomeInformationFailed = error => {
    return {
      type: APPLICATION_INCOME_INFORMATION_FAILED,
      payload: error,
    }
  }
  
  export const applicationResidencyInformation = (applicantType, residency, history) => {
    return {
      type: APPLICATION_RESIDENCY_INFORMATION,
      payload: { applicantType, residency, history },
    }
  }
  
  export const applicationResidencyInformationSuccessful = residency => {    
    return {
      type:  APPLICATION_RESIDENCY_INFORMATION_SUCCESSFUL,
      payload: residency,
    }
  }
  
  export const applicationResidencyInformationFailed = error => {
    return {
      type: APPLICATION_RESIDENCY_INFORMATION_FAILED,
      payload: error,
    }
  }
  
  export const applicationReferenceInformation = (applicantType, reference, history) => {
    return {
      type: APPLICATION_REFERENCE_INFORMATION,
      payload: { applicantType, reference, history },
    }
  }
  
  export const applicationReferenceInformationSuccessful = reference => {    
    return {
      type:  APPLICATION_REFERENCE_INFORMATION_SUCCESSFUL,
      payload: reference,
    }
  }
  
  export const applicationReferenceInformationFailed = error => {
    return {
      type: APPLICATION_REFERENCE_INFORMATION_FAILED,
      payload: error,
    }
  }
  
  export const applicationAccessCode = (applicantType, data, history) => {
    return {
      type: APPLICATION_ACCESS_CODE,
      payload: { applicantType, data, history },
    }
  }
  
  export const applicationAccessCodeSuccessful = data => {    
    return {
      type:  APPLICATION_ACCESS_CODE_SUCCESSFUL,
      payload: data,
    }
  }
  
  export const applicationAccessCodeFailed = error => {
    return {
      type: APPLICATION_ACCESS_CODE_FAILED,
      payload: error,
    }
  }
  
  export const applicationValidateAccessCode = (applicantType, data, history) => {
    return {
      type: APPLICATION_VALIDATE_ACCESS_CODE,
      payload: { applicantType, data, history },
    }
  }
  
  export const applicationValidateAccessCodeSuccessful = data => {    
    return {
      type:  APPLICATION_VALIDATE_ACCESS_CODE_SUCCESSFUL,
      payload: data,
    }
  }
  
  export const applicationValidateAccessCodeFailed = error => {
    return {
      type: APPLICATION_VALIDATE_ACCESS_CODE_FAILED,
      payload: error,
    }
  }
  
  export const applicationStartCoSigner = (applicantType, data, history) => {
    return {
      type: APPLICATION_START_CO_SIGNER,
      payload: { applicantType, data, history },
    }
  }
  
  export const applicationStartCoSignerSuccessful = data => {    
    return {
      type:  APPLICATION_START_CO_SIGNER_SUCCESSFUL,
      payload: data,
    }
  }
  
  export const applicationStartCoSignerFailed = error => {
    return {
      type: APPLICATION_START_CO_SIGNER_FAILED,
      payload: error,
    }
  }
  
  export const applicationInviteCoEmail = (applicantType, data, history) => {
    return {
      type: APPLICATION_INVITE_CO_EMAIL,
      payload: { applicantType, data, history },
    }
  }
  
  export const applicationInviteCoEmailSuccessful = data => {    
    return {
      type:  APPLICATION_INVITE_CO_EMAIL_SUCCESSFUL,
      payload: data,
    }
  }
  
  export const applicationInviteCoEmailFailed = error => {
    return {
      type: APPLICATION_INVITE_CO_EMAIL_FAILED,
      payload: error,
    }
  }
  
  export const applicationInviteCoSms = (applicantType, data, history) => {
    return {
      type: APPLICATION_INVITE_CO_SMS,
      payload: { applicantType, data, history },
    }
  }
  
  export const applicationInviteCoSmsSuccessful = data => {    
    return {
      type:  APPLICATION_INVITE_CO_SMS_SUCCESSFUL,
      payload: data,
    }
  }
  
  export const applicationInviteCoSmsFailed = error => {
    return {
      type: APPLICATION_INVITE_CO_SMS_FAILED,
      payload: error,
    }
  }
  
  